let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1GPFH")).then(() => parcelRequire('msaV2'));